import { c as _c } from "react/compiler-runtime";
import { FormInput, FormSelect } from '@systemeio/ui';
import { ErrorResponseContentInterface } from '@systemeio/util';
import { WiseRecipientFormFieldTypesEnum } from 'modules/profile/affiliate-settings/enums/wise-recipient-form-field-types-enum';
import { useWiseRecipientApi } from 'modules/profile/affiliate-settings/hooks/use-wise-recipient-api';
import { WiseRecipientApiInterface } from 'modules/profile/affiliate-settings/types/affiliate-settings-interface';
import { WiseRecipientDetailsFieldInterface, WiseRecipientDetailsInterface, WiseRecipientDetailsItemInterface } from 'modules/profile/affiliate-settings/types/wise-details-interface';
import { useEffect, useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface AdditionalFormFieldsProps {
  formData: WiseRecipientDetailsInterface | null;
  setFormData: React.Dispatch<React.SetStateAction<WiseRecipientDetailsInterface | null>>;
  state: WiseRecipientApiInterface;
  onChangeDetails: (key: string, value: string) => void;
  fieldErrors: ErrorResponseContentInterface['fields'];
  onChangeRecipientDetailsType: (value: string) => void;
  resetFormErrors: () => void;
  updateFormDetails: (details: Record<string, string>) => void;
}
export function AdditionalFormFields(t0) {
  const $ = _c(31);
  const {
    formData,
    setFormData,
    onChangeDetails,
    state,
    fieldErrors,
    onChangeRecipientDetailsType,
    resetFormErrors,
    updateFormDetails
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const isTypeOfRecipientDetailsSelect = !!formData;
  const [activeForm, setActiveForm] = useState();
  const [isActiveFormFetching, setIsActiveFormFetching] = useState(false);
  let t1;
  if ($[0] !== formData || $[1] !== isTypeOfRecipientDetailsSelect) {
    t1 = isTypeOfRecipientDetailsSelect ? Object.keys(formData).map(formTypeKey => ({
      id: formData[formTypeKey].type,
      caption: formData[formTypeKey].title
    })) : [];
    $[0] = formData;
    $[1] = isTypeOfRecipientDetailsSelect;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const typeOfRecipientDetailsSelectData = t1;
  const {
    getCurrentWiseRecipientDetails
  } = useWiseRecipientApi();
  let t2;
  if ($[3] !== getCurrentWiseRecipientDetails || $[4] !== onChangeDetails || $[5] !== resetFormErrors || $[6] !== setFormData || $[7] !== state || $[8] !== updateFormDetails) {
    t2 = async (field, data) => {
      resetFormErrors();
      onChangeDetails(field.group[0].key, data);
      if (field.group[0].refreshRequirementsOnChange) {
        const updatedDetailsFields = {
          ...state.details,
          [field.group[0].key]: data
        };
        setIsActiveFormFetching(true);
        const updatedState = {
          ...state,
          details: updatedDetailsFields
        };
        const responseData = await getCurrentWiseRecipientDetails(state.currency, updatedState);
        const formFields = responseData[state.recipientDetailsType].fields.map(_temp);
        Object.keys(state.details).forEach(fieldKey => {
          if (!formFields.includes(fieldKey)) {
            delete updatedDetailsFields[fieldKey];
          }
        });
        setFormData(responseData);
        updateFormDetails(updatedDetailsFields);
        setIsActiveFormFetching(false);
      }
    };
    $[3] = getCurrentWiseRecipientDetails;
    $[4] = onChangeDetails;
    $[5] = resetFormErrors;
    $[6] = setFormData;
    $[7] = state;
    $[8] = updateFormDetails;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const handleFormSelectChange = t2;
  let t3;
  let t4;
  if ($[10] !== formData || $[11] !== state.recipientDetailsType) {
    t3 = () => {
      if (formData && formData[state.recipientDetailsType]) {
        setActiveForm(formData[state.recipientDetailsType]);
      }
    };
    t4 = [formData, state.recipientDetailsType];
    $[10] = formData;
    $[11] = state.recipientDetailsType;
    $[12] = t3;
    $[13] = t4;
  } else {
    t3 = $[12];
    t4 = $[13];
  }
  useEffect(t3, t4);
  let t5;
  if ($[14] !== activeForm?.type || $[15] !== formData || $[16] !== isTypeOfRecipientDetailsSelect || $[17] !== onChangeRecipientDetailsType || $[18] !== t || $[19] !== typeOfRecipientDetailsSelectData) {
    t5 = isTypeOfRecipientDetailsSelect && <FormSelect data={typeOfRecipientDetailsSelectData} label={t("dashboard.user_settings.affiliate_commissions.wire_table.recipient_type_title")} placeholder={t("dashboard.user_settings.affiliate_commissions.wire_table.recipient_type_placeholder")} value={activeForm?.type} onChange={data_0 => {
      const updatedRecipientDetailsType = Object.keys(formData).find(formTypeKey_0 => formData[formTypeKey_0].type === data_0);
      if (updatedRecipientDetailsType) {
        onChangeRecipientDetailsType(formData[updatedRecipientDetailsType].type);
        setActiveForm(formData[updatedRecipientDetailsType]);
      }
    }} withoutCloseIcon={true} required={true} />;
    $[14] = activeForm?.type;
    $[15] = formData;
    $[16] = isTypeOfRecipientDetailsSelect;
    $[17] = onChangeRecipientDetailsType;
    $[18] = t;
    $[19] = typeOfRecipientDetailsSelectData;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== activeForm?.fields || $[22] !== fieldErrors || $[23] !== handleFormSelectChange || $[24] !== isActiveFormFetching || $[25] !== onChangeDetails || $[26] !== state) {
    t6 = activeForm?.fields.map(field_1 => getFormField(field_1, onChangeDetails, handleFormSelectChange, state, fieldErrors, isActiveFormFetching));
    $[21] = activeForm?.fields;
    $[22] = fieldErrors;
    $[23] = handleFormSelectChange;
    $[24] = isActiveFormFetching;
    $[25] = onChangeDetails;
    $[26] = state;
    $[27] = t6;
  } else {
    t6 = $[27];
  }
  let t7;
  if ($[28] !== t5 || $[29] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  return t7;
}
function _temp(field_0) {
  return field_0.group[0].key;
}
export function getFormField(field: WiseRecipientDetailsFieldInterface, onChange: (key: string, value: string) => void, onChangeDetailsWithFormUpdate: (field: WiseRecipientDetailsFieldInterface, data: string) => Promise<void>, state: WiseRecipientApiInterface, fieldErrors: ErrorResponseContentInterface['fields'], isActiveFormFetching: boolean) {
  switch (field.group[0].type) {
    case WiseRecipientFormFieldTypesEnum.select:
    case WiseRecipientFormFieldTypesEnum.radio:
      return <FormSelect data={field.group[0].valuesAllowed?.map(el => {
        return {
          ...el,
          id: el.key,
          caption: el.name
        };
      })} label={field.group[0].name} value={state.details[field.group[0].key] || ''} onChange={data => {
        if (data) {
          onChangeDetailsWithFormUpdate(field, data);
        }
      }} withoutCloseIcon required={field.group[0].required} error={fieldErrors[field.group[0].key]?.join('')} disabled={isActiveFormFetching} key={field.group[0].key} />;
    case WiseRecipientFormFieldTypesEnum.date:
    case WiseRecipientFormFieldTypesEnum.text:
      return <FormInput value={state.details[field.group[0].key] || ''} label={field.group[0].name} onChange={e => onChange(field.group[0].key, e.target.value)} required={field.group[0].required} error={fieldErrors[field.group[0].key]?.join('')} disabled={isActiveFormFetching} key={field.group[0].key} />;
    default:
      break;
  }
}